export default __webpack_public_path__ + "static/media/instagramButton.b61c39c9.png";